import {AssetsRequestParams} from "../../../../infrastructure/models/params/assets-request-params";
import {IMAGE_DEFAULT_FORMATS} from "../../../app/consts";

export class DisclaimerRequestParams extends AssetsRequestParams {
  constructor(width: Number, height: Number, langId: Number) {
    super(width, height);

    this.resourceName = `${this.resourceName}/DisclaimerByLangId/${langId}`;
    this.ratio = 3;
    this.version = 4;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.PNG;
  }
}